export default __webpack_public_path__ + "5af7c3b0eae826c71088934c1ce30b8c.webp";